import * as React from 'react';
import { useSearch } from '@elastic/react-search-ui';
import { useChartBridge } from '../ChartBridgeContext';
import { buildShareUrl } from '../shareParams';
import { uiText } from '../../helpers';
import { Button } from '@nvidia/foundations-react-core/Button';

// Share control for the OpenSearch chart: encodes the current selection —
// row filters (read from the search context),
// group, Y-axis field, axis-switcher selection and view — into a permalink and
// copies it. The params are consumed and stripped on load by this folder's
// Provider (stripSharedParams), so the URL only carries them right after a
// Share click.
export function ShareButton({ groupLabel, viewMode, yField }) {
  const { filters } = useSearch();
  const { selected: axisField } = useChartBridge();
  const [copied, setCopied] = React.useState(false);

  const handleShare = () => {
    const clip = typeof navigator !== 'undefined' && navigator.clipboard;
    if (!clip || !clip.writeText) return;
    const url = buildShareUrl({ groupLabel, filters, yField, axisField, viewMode });
    clip.writeText(url).then(
      () => {
        setCopied(true);
        window.setTimeout(() => setCopied(false), 2000);
      },
      () => { /* clipboard denied — leave the label unchanged */ }
    );
  };

  return (
    <>
      <Button kind='secondary' size='medium' onClick={handleShare} color="brand">
        {copied ? uiText('copied', 'Copied!') : uiText('share', 'Share')}
      </Button>
      {/* A button's own label change isn't announced; a polite live region is. */}
      <span className='visually-hidden' aria-live='polite'>
        {copied ? uiText('link_copied', 'Link copied to clipboard') : ''}
      </span>
    </>
  );
}
